import React, { useState } from 'react';
import { createCheckoutSession } from '../../services/paymentService';

const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;

// Shown once a group has an active plan: displays current scan usage and
// lets the owner buy more scans or upgrade Starter -> Community.
const ManageAddons = ({ subscription, addons, isOwner, onUpdate, communityMaxMembers }) => {
  const [purchasing, setPurchasing] = useState(null); // 'upgrade' | 'scan_pack' | null
  const [error, setError] = useState('');

  const scanPack = addons?.find((a) => a.addon_key === 'scan_pack');
  const upgrade = addons?.find((a) => a.addon_key === 'community_upgrade');
  const isStarter = subscription?.plan === 'starter';

  const handlePurchase = async (purchaseType) => {
    setPurchasing(purchaseType);
    setError('');
    try {
      const data = await createCheckoutSession(purchaseType);
      window.location.href = data.url;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to start checkout');
      setPurchasing(null);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.scanRow}>
        <span style={styles.scanLabel}>📷 Recipe Photo Scans</span>
        <span style={styles.scanCount}>
          {subscription?.scan_count ?? 0} / {subscription?.scan_limit ?? 0} used
        </span>
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.buttonRow}>
        {scanPack && (
          <button
            onClick={() => handlePurchase('scan_pack')}
            style={styles.secondaryBtn}
            disabled={purchasing === 'scan_pack'}
          >
            {purchasing === 'scan_pack'
              ? 'Redirecting...'
              : `+${scanPack.scan_amount} Scans for ${formatPrice(scanPack.price_cents)}`}
          </button>
        )}
        {isOwner && isStarter && upgrade && (
          <button
            onClick={() => handlePurchase('upgrade')}
            style={styles.primaryBtn}
            disabled={purchasing === 'upgrade'}
          >
            {purchasing === 'upgrade'
              ? 'Redirecting...'
              : `Upgrade to ${communityMaxMembers ?? 30} Users for ${formatPrice(upgrade.price_cents)}`}
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginBottom: '24px',
  },
  scanRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '14px',
    flexWrap: 'wrap',
    gap: '8px',
  },
  scanLabel: { color: '#333', fontWeight: '600', fontSize: '14px' },
  scanCount: { color: '#e67e22', fontWeight: '700', fontSize: '14px' },
  buttonRow: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
  primaryBtn: {
    padding: '10px 18px',
    backgroundColor: '#e67e22',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '13px',
  },
  secondaryBtn: {
    padding: '10px 18px',
    backgroundColor: 'white',
    color: '#e67e22',
    border: '1px solid #e67e22',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '13px',
  },
  error: { color: '#e74c3c', fontSize: '13px', marginBottom: '10px' },
};

export default ManageAddons;
